import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastController } from '@ionic/angular';
import { DataService } from '../../data.service';

// Admin → Felület → Mobil app / IdP-címtár. A deploy ÖNREGISZTRÁL a központi (Cloudflare)
// intézmény/IdP-választó címtárba, hogy megjelenjen a mobil app belépés előtti választójában.
@Component({
  selector: 'app-idp-regisztracio',
  templateUrl: './idp-regisztracio.component.html',
  styleUrls: ['./idp-regisztracio.component.scss'],
})
export class IdpRegisztracioComponent implements OnInit {
  private readonly base = '/api/idp-directory';
  sajatIntezmeny: any;
  betolt = false;
  fut = false;
  van_kulcs = false;
  utolso_reg: string | null = null;
  utolso_eredmeny: string | null = null;
  form: any = { directory_url: '', registry_key: '', reg_id: '', nev: '', base_domain: '', idp: '', api: '', avatars: '', forum: '', n8n: '', logo: '', sorrend: 100 };

  constructor(private http: HttpClient, private data: DataService, private toast: ToastController) {}

  get intezmeny() { return this.sajatIntezmeny?.intezmenyId || ''; }

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    if (this.intezmeny) await this.betoltMind();
  }

  // A deploy base domainje a jelenlegi hostból (erp.zenit.sulinform.hu → zenit.sulinform.hu).
  private deriveBaseDomain(): string {
    try {
      const host = window.location.hostname;
      const parts = host.split('.');
      const known = ['idp', 'n8n', 'erp', 'avatars', 'forum', 'phpmyadmin', 'minio'];
      if (parts.length >= 3 && known.includes(parts[0])) return parts.slice(1).join('.');
      return host;
    } catch { return ''; }
  }

  async betoltMind() {
    this.betolt = true;
    try {
      const r: any = await this.http.get(`${this.base}/beallitas/${this.intezmeny}`).toPromise();
      this.van_kulcs = !!r?.van_kulcs;
      this.utolso_reg = r?.utolso_reg || null;
      this.utolso_eredmeny = r?.utolso_eredmeny || null;
      this.form = {
        directory_url: r?.directory_url || '',
        registry_key: '',
        reg_id: r?.reg_id || '',
        nev: r?.nev || this.sajatIntezmeny?.intezmenyName || '',
        base_domain: r?.base_domain || this.deriveBaseDomain(),
        idp: r?.idp || '',
        api: r?.api || '',
        avatars: r?.avatars || '',
        forum: r?.forum || '',
        n8n: r?.n8n || '',
        logo: r?.logo || this.sajatIntezmeny?.intezmenyKep || '',
        sorrend: r?.sorrend ?? 100,
      };
    } catch { /* csendes */ }
    this.betolt = false;
  }

  async ment() {
    try {
      await this.http.put(`${this.base}/beallitas/${this.intezmeny}`, this.form).toPromise();
      this.form.registry_key = '';
      await this.uzen('Beállítás mentve.', 'success');
      await this.betoltMind();
    } catch (e: any) { await this.uzen(e?.error?.error || 'Mentési hiba.', 'danger'); }
  }

  async regisztral() {
    this.fut = true;
    try {
      await this.http.post(`${this.base}/regisztracio/${this.intezmeny}`, {}).toPromise();
      await this.uzen('Sikeres regisztráció a központhoz.', 'success');
      await this.betoltMind();
    } catch (e: any) { await this.uzen(e?.error?.error || 'Regisztrációs hiba.', 'danger'); }
    this.fut = false;
  }

  async torol() {
    this.fut = true;
    try {
      await this.http.post(`${this.base}/torles/${this.intezmeny}`, {}).toPromise();
      await this.uzen('Kivéve a központból.', 'medium');
      await this.betoltMind();
    } catch (e: any) { await this.uzen(e?.error?.error || 'Törlési hiba.', 'danger'); }
    this.fut = false;
  }

  private async uzen(m: string, color: string) { (await this.toast.create({ message: m, duration: 2600, color })).present(); }
}
